import { Operation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { moveVariableSet, MoveVariableSetAction, ActionTypes } from 'store/data/variables';
import { ActionPayload } from 'store/types';

export function useMoveVariableSet(): Operation<
	(payload: ActionPayload<MoveVariableSetAction>) => void
> {
	const dispatch = useDispatch();

	const [{ loading, error }] = useActivity(ActionTypes.MOVE_VARIABLE_SET);

	function handler(payload: ActionPayload<MoveVariableSetAction>) {
		dispatch(moveVariableSet(payload));
	}

	return [{ loading, error }, handler];
}
